module.exports = "images/LunaPark5.jpg";